import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container, Box, Typography, Grid, Button
} from '@mui/material';
import ReactCrop from 'react-image-crop';
import { useStyles } from './style';
import { Camera } from '../shared/Camera';
import { useDebounceEffect } from '../../hooks/useDebounceEffect';
import { canvasToBase64Image, centerAspectCrop } from '../../utils/generalFunc';

import { profileInfoAction } from '../../redux/profile/Reducer';
import { backCardImageAction } from '../../redux/camera/Reducer';

export const CardBackCamera = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const captureCamera = useRef();
  const [cameraType, setCameraType] = useState('start');
  const [imgSrc, setImgSrc] = useState('');
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [aspect] = useState(16 / 9);
  const [isCropping, setIsCropping] = useState(true);
  const profile = useSelector((state) => state.profile.profilInfo);

  const handleCapturePhoto = () => {
    const captureBase64Image = captureCamera.current.getScreenshot();
    setImgSrc(captureBase64Image);
    setCameraType('stop');
    setIsCropping(true);
  };

  const handleCaptureRetake = () => {
    setCameraType('start');
    setIsCropping(false);
  };

  const takePhotoBackHandler = () => {
    history.push('/card-view');
  };

  const nextClickHandler = () => {
    history.push('/card-verify');
    dispatch(profileInfoAction({
      ...profile,
      InsuranceCardPhotoBack: ''
    }));
  };
  useDebounceEffect(async () => {
    if (imgRef.current) {
      const base64Image = await canvasToBase64Image(imgRef.current, completedCrop);
      dispatch(backCardImageAction(base64Image));
    }
  }, 100, [completedCrop, isCropping]);

  function onImageLoad(e) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
    }
  }

  const cameraRenderWithImage = () => {
    if (cameraType === 'start') {
      return (
        <>
          <Box className={classes.cameraFaceBorder} />
          <Box className={classes.cameraOpenWrapper}>
            <Camera ref={captureCamera} />
          </Box>
        </>
      );
    }
    return null;
  };

  const cameraRenderWithImageCrop = () => {
    if (isCropping) {
      return (
        <ReactCrop
          crop={crop}
          onChange={(_, percentCrop) => setCrop(percentCrop)}
          onComplete={(c) => {
            setCompletedCrop(c);
          }}
        >
          <img
            ref={imgRef}
            alt="card_front_crop"
            src={imgSrc}
            onLoad={onImageLoad}
            className={classes.cameraTakeView}
          />
        </ReactCrop>
      );
    }
    return null;
  };

  // eslint-disable-next-line consistent-return
  const cameraButtonChangeHandler = () => {
    if (cameraType === 'start') {
      return (
        <Grid container rowSpacing={{ xs: 3, sm: 2, md: 4 }}>
          <Grid item xs={12} md={6} className={classes.secondaryBtnWrapper}>
            <Box px={2}>
              <Button variant="contained" color="primary" onClick={handleCapturePhoto}>
                Take Photo
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} className={classes.primaryBtnWrapper}>
            <Box px={2}>
              <Button variant="contained" color="secondary" onClick={takePhotoBackHandler}>
                Back
              </Button>
            </Box>
          </Grid>
        </Grid>
      );
    }

    return (
      <Grid container rowSpacing={{ xs: 3, sm: 2, md: 4 }}>
        <Grid item xs={12} md={6} className={classes.secondaryBtnWrapper}>
          <Box px={2}>
            <Button variant="contained" color="primary" onClick={nextClickHandler}>
              Next
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} className={classes.primaryBtnWrapper}>
          <Box px={2}>
            <Button variant="contained" color="secondary" onClick={handleCaptureRetake}>
              Retake
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  };

  return (
    <Container maxWidth="md">
      <Box textAlign="center" py={4}>
        <Box className={classes.heading}>{cameraType === 'start' ? 'Back of Card' : 'Look Good?'}</Box>
      </Box>
      <Box className={classes.cameraMainConatiner}>
        <Box className={classes.cameraFrameContainer}>
          {cameraType === 'start' ? cameraRenderWithImage() : cameraRenderWithImageCrop()}
        </Box>
      </Box>
      <Box textAlign="center" py={2}>
        <Typography variant="body1">
          Please ensure the picture is in focus, there is no glare and your card is on a plain background.
        </Typography>
      </Box>
      <Box className={classes.root}>
        {cameraButtonChangeHandler()}
      </Box>
    </Container>
  );
};
